import { IPlan, TermUnit } from './models';

export function termToCycleDays(term: TermUnit): number {
    switch (term) {
        case TermUnit.DAY:  return 1;
        case TermUnit.WEEK: return 7;
        case TermUnit.YEAR: return 365;
        case TermUnit.MONTH:
        default:            return 30;
    }
}

export function termToMonthlyDivisor(term: TermUnit): number {
    switch (term) {
        case TermUnit.DAY:  return 1 / 30;
        case TermUnit.WEEK: return 7 / 30;
        case TermUnit.MONTH: return 1;
        case TermUnit.YEAR:  return 12;
        case TermUnit.ONCE:
        default: return 1;
    }
}

export function isDowngradePlan(currentPlan: IPlan | null, targetPlan: IPlan): boolean {
    return currentPlan?.priority != null
        && targetPlan.priority != null
        && currentPlan.priority > targetPlan.priority;
}

export function getPlanChangeCost(
    currentPlan: IPlan | null,
    targetPlan: IPlan,
    orgBillingCycle: TermUnit
): number {
    if (isDowngradePlan(currentPlan, targetPlan)) return 0;

    const currentPrice = currentPlan?.pricing
        ?.find((p: any) => p.term === orgBillingCycle)?.price ?? 0;
    const targetPrice = targetPlan.pricing
        ?.find((p: any) => p.term === orgBillingCycle)?.price ?? 0;

    return Math.max(0, targetPrice - currentPrice);
}
